import React from 'react';
import PropTypes from 'prop-types';

import './styles.scss';

const toggle = props => {
  const { status, title, onClick, dataAttribute } = props;

  return (
    <div
      className={`toggle-button os-toggler-w ${status ? 'on' : 'off'}`}
      title={title}
    >
      <div className="os-toggler-i">
        <div className="os-toggler-pill"  onClick={onClick}
             data-attribute={dataAttribute}/>
      </div>
    </div>
  );
};

toggle.defaultProps = {
  onClick: () => null,
  title: '',
  dataAttribute: '',
};

toggle.propTypes = {
  status: PropTypes.bool.isRequired,
  title: PropTypes.string,
  onClick: PropTypes.func,
  dataAttribute: PropTypes.string,
};

export default toggle;
